export default "__VITE_ASSET__DJIR7eNq__"